import roundDecimals from '../roundDecimals';

/**
 * @param value Number to round
 * @param decimals Exact amount of desired decimal places
 * @returns Passed number rounded to exact number of decimal places
 *
 * @example
 * roundToExactNumberOfDecimals(3.14159, 3)
 * // Returns  3.142
 */
const roundToExactNumberOfDecimals = (
  value: number,
  decimals: number,
): string => roundDecimals(value, decimals).toFixed(decimals);

export default roundToExactNumberOfDecimals;
